<template>
	<div class="ma-3">
		<v-dialog v-model="dialogModel">
			<v-carousel v-model="carouselModel" height="100%">
				<v-btn
					class="close-dialog-button"
					@click="closeDialog()"
					small
					light
					fab
				>
					<v-icon large>mdi-close</v-icon>
				</v-btn>
				<v-carousel-item
					v-for="image in carouselTotalImages"
					:key="image"
				>
					<img
						class="full-width"
						:src="require(`@/assets/images/projects/${projectPath}/${device}-${image}.webp`)"
					/>
				</v-carousel-item>
			</v-carousel>
		</v-dialog>

		<v-row
			v-for="category in portfolioCategories"
			:key="category.id"
		>
			<v-col align="center" cols="12">
				<h2 class="title">{{category.name}}</h2>
			</v-col>
			<v-col
				v-for="project in category.projects"
				:key="project.id"
				cols="12" lg="3" md="4" sm="6"
			>
				<v-card
					color="grey lighten-3"
					elevation="4"
					outlined
					tile
				>
					<img
						class="full-width pointer"
						:src="require(`@/assets/images/projects/${project.imagesFolder}/d-1.webp`)"
						@click="showDialog(project)"
					/>
					
					<v-card-title
						class="pt-2 pb-0 justify-center text-break text-center"
					>
						{{project.title}}
					</v-card-title>
					<v-card-actions>
						<v-btn
							class="font-weight-bold"
							:color="inlineStyles.greetingText.color"
							@click="hasRevealed = true"
							text
						>
							Details
						</v-btn>
						<v-spacer />
						<v-btn
							class="font-weight-bold"
							:color="inlineStyles.greetingText.color"
							:href="project.url"
							target="_blank"
							text
						>
							Visit Site
							<v-icon>mdi-chevron-right</v-icon>
						</v-btn>
					</v-card-actions>

					<v-expand-transition>
						<v-card
							v-if="hasRevealed"
							class="transition-fast-in-fast-out v-card--reveal"
							color="blue-grey lighten-5"
							tile
						>
							<v-card-text
								class="pa-3 text-justify text--primary"
								v-html="project.description"
							/>
							<v-card-actions>
								<v-btn
									class="font-weight-bold"
									:color="inlineStyles.greetingText.color"
									@click="hasRevealed = false"
									text
								>
									Hide
								</v-btn>
								<v-spacer />
								<v-btn
									class="font-weight-bold"
									:color="inlineStyles.greetingText.color"
									:href="project.url"
									target="_blank"
									text
								>
									Visit Site
									<v-icon>mdi-chevron-right</v-icon>
								</v-btn>
							</v-card-actions>
						</v-card>
					</v-expand-transition>
				</v-card>
			</v-col>
		</v-row>
	</div>
</template>

<script scoped>
export default {
	name: "PortfolioView",
	props:{
		inlineStyles: {
			type: Object,
			require: true
		},
		windowSize: {
			type: Object,
			require: true
		}
	},
	data: () => ({
		carouselModel: 0,
		carouselTotalImages: 0,
		projectPath: "",
		dialogModel: false,
		hasRevealed: false,
		portfolioCategories: [
			{
				id: 0,
				name: "API Consumption",
				projects: [
					{
						id: 0,
						title: "Movie Particles",
						description: "Get Movies and TV Shows Data in Particulate Form.<br/>API: <a href='https://developers.themoviedb.org/' target='_blank'>https://developers.themoviedb.org/</a>",
						imagesFolder: "movie-particles",
						totalImages: 7,
						url: "https://movie-particles.web.app/",
					}
				]
			}
		]
	}),
	computed: {
		device() {
			const {width, height} = this.windowSize
			return (width/height < 0.666 ? "m" : "d")
		}
	},
	methods: {
		closeDialog() {
			this.dialogModel = false
		},
		showDialog(projectData) {
			const {imagesFolder, totalImages} = projectData

			this.carouselTotalImages = totalImages
			this.projectPath = imagesFolder
			this.carouselModel = 0
			this.dialogModel = true
		}
	}
}
</script>

<style scoped>
/* Normal Styles */
.close-dialog-button {
	position: absolute;
	top: 4px;
	right: 4px;
	z-index: 9
}
.full-width {
	width: 100%;
}
.pointer {
	cursor: pointer;
}
.title {
	text-shadow: 2px 2px 4px black;
	text-transform: capitalize;
}

/* Vuetify Modify styles */
::v-deep .v-dialog {
	overflow-y: hidden;
}

/* Animations */
.v-card--reveal {
	position: absolute;
	bottom: 0;
	width: 100%;
	outline: 1px solid rgb(0 0 0 / .87);
}
</style>